import styled from "styled-components";

export const ModernPlanCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  width: 100%;
  border-radius: 16px;
  padding: 12px 12px 20px;
  border: 1px solid rgba(10, 13, 18, 0.1);
  background: #fff;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }

  .plan-header {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 1rem;
    border-radius: 12px;

    .plan-name {
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      background: linear-gradient(90deg, #535862 0%, #717680 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0;
    }

    .pricing-section {
      .price-display {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
      }

      .price-amount {
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
        background: linear-gradient(45deg, #252b37 0%, #535862 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &.line-through {
          text-decoration: line-through;
          opacity: 0.7;
        }

        &.discounted {
          color: #fbbf24;
          margin-left: 8px;
        }

        &.custom {
          font-size: 36px;
          font-weight: 600;
        }

        .dot-price {
          font-size: 32px;
          vertical-align: top;
          font-weight: 600;
        }
      }

      .price-period {
        font-size: 14px;
        font-weight: 400;
        font-family: "Geist", sans-serif;
        line-height: 20px;
        background: linear-gradient(45deg, #252b37 0%, #535862 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-left: 4px;
      }

      .yearly-badge {
        margin-left: 4px;
        padding: 2px 8px 2px 6px;
        border-radius: 12px;
        background: #eff5ff;
        border: 1px solid #bdd8ff;
        color: #1841dd;
        font-size: 12px;
        font-weight: 500;
        font-family: "Geist", sans-serif;
        line-height: 18px;
        display: inline-block;
        text-transform: uppercase;
      }

      .custom-description {
        font-size: 14px;
        color: #000;
        font-family: "Geist", sans-serif;
        margin-top: 8px;
        line-height: 1.4;
      }
    }

    .plan-description {
      font-size: 12px;
      font-weight: 400;
      font-family: "Geist", sans-serif;
      color: rgba(10, 13, 18, 0.6);
      line-height: 18px;
      margin: 0;
    }
  }

  .plan-header.header-silver {
    background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
  }

  .plan-header.header-green {
    background: linear-gradient(180deg, #f6faf3 0%, #e8f5e4 100%);
  }

  .plan-header.header-blue {
    background: linear-gradient(180deg, #f3f7fa 0%, #e4ecf5 100%);
  }

  .plan-header.header-warm {
    background: linear-gradient(
      45deg,
      rgba(223, 209, 197, 0.6) 0%,
      rgba(255, 246, 235, 0.6) 100%
    );
  }

  .plan-details-wrapper {
    padding: 20px 8px 0px;

    .button-section {
      .plan-button {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 10px 8px;
        border-radius: 8px;
        border: 1px solid #d5d7da;
        background: #fff;
        box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
          0 -2px 0 0 rgba(10, 13, 18, 0.05) inset,
          0 1px 2px 0 rgba(10, 13, 18, 0.05);
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
          background: #f8f9fa;
          border-color: #c1c4c8;
        }

        &:disabled {
          cursor: not-allowed;
          opacity: 0.6;
          background: #f5f6f7;
        }

        .button-loader {
          width: 16px !important;
          height: 16px !important;
        }

        .button-text {
          font-family: "Geist", sans-serif;
          color: rgba(10, 13, 18, 0.7);
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
      }
    }

    .benefits-section {
      flex: 1;
      margin-top: 20px;

      p {
        font-size: 14px;
        font-family: "Geist", sans-serif;
        font-weight: 400;
        color: rgba(10, 13, 18, 0.6);
        line-height: 20px;
        margin-bottom: 20px;
      }

      .benefits-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .benefit-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;

        .check-icon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 2px;

          svg {
            width: 16px;
            height: 16px;
          }
        }

        .benefit-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;

          .benefit-tag {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 13px;
            font-weight: 500;
            color: black;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 4px;
            width: fit-content;
          }

          .benefit-text {
            font-size: 14px;
            font-weight: 400;
            font-family: "Geist", sans-serif;
            color: rgba(10, 13, 18, 0.6);
            line-height: 20px;
          }
        }
      }
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    padding: 24px 20px;
    min-height: 450px;
    max-width: 100%;

    .plan-header {
      margin-bottom: 20px;

      .plan-name {
        font-size: 12px;
      }
    }

    .pricing-section {
      margin-bottom: 24px;

      .price-amount {
        font-size: 38px;

        &.custom {
          font-size: 30px;
        }

        .dot-price {
          font-size: 26px;
        }
      }

      .price-period {
        font-size: 13px;
      }
    }

    .plan-description {
      margin-bottom: 20px;

      p {
        font-size: 15px;
      }
    }

    .benefits-section {
      margin-bottom: 24px;

      .benefits-list {
        gap: 12px;
      }

      .benefit-item {
        gap: 10px;
        padding-bottom: 12px;

        .benefit-content {
          .benefit-text {
            font-size: 12px;
          }
        }
      }
    }

    .button-section {
      .plan-button {
        padding: 14px 20px !important;
        font-size: 15px !important;
        min-height: 48px !important;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
    min-height: 400px;

    .plan-header {
      margin-bottom: 16px;

      .plan-name {
        font-size: 11px;
      }
    }

    .pricing-section {
      margin-bottom: 20px;

      .price-amount {
        font-size: 34px;

        &.custom {
          font-size: 26px;
        }

        .dot-price {
          font-size: 22px;
        }
      }

      .price-period {
        font-size: 12px;
      }
    }

    .benefits-section {
      margin-bottom: 20px;

      .benefits-list {
        gap: 10px;
      }

      .benefit-item {
        gap: 8px;
        padding-bottom: 10px;

        .check-icon {
          width: 18px;
          height: 18px;

          svg {
            width: 14px;
            height: 14px;
          }
        }

        .benefit-content {
          .benefit-text {
            font-size: 11px;
          }
        }
      }
    }
  }
`;
